<template>
  <div class="dashboard-pages">
    <v-card class="pa-3">
      <v-flex>
        <dt-search-box @typing="searchValue" @reset-datatable="resetDataTable()" @clear-search-field="search = null" />
      </v-flex>
    </v-card>

    <v-card flat>
      <v-layout row>
        <v-layout row wrap justify-start align-end>
          <v-flex pa-2>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  style="margin:0 10px 0; height: 30px; width: 30px;"
                  :loading="loadThePrintBtn"
                  flat
                  fab
                  v-on="on"
                  color="primary"
                  @click="getNoPaginatedData('print')"
                >
                  <v-icon>print</v-icon>
                </v-btn>
              </template>
              <span>{{ $t(`Print Table`) }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  style="margin: 0; height: 30px; width: 30px"
                  fab
                  :loading="loadTheExportBtn"
                  flat
                  v-on="on"
                  color="primary"
                  @click="getNoPaginatedData('export')"
                >
                  <v-icon>fa-file-excel</v-icon>
                </v-btn>
              </template>
              <span>{{ $t(`Export Table`) }}</span>
            </v-tooltip>
          </v-flex>
        </v-layout>

        <v-layout row justify-end>
          <v-flex shrink pa-2>
            <v-autocomplete
              v-if="hasPermissions(['outlet_select'])"
              v-model="outletId"
              :label="`${$t('Outlet')} *`"
              hide-details
              :items="outletsList"
              @input="updateDatatableResult()"
              data-vv-name="outlet"
              :error="errors.has('outlet')"
              v-validate="'required'"
            />
          </v-flex>

          <v-flex shrink pa-2>
            <v-menu v-model="theDateMenu" full-width max-width="290" :close-on-content-click="false">
              <v-text-field
                slot="activator"
                :value="date"
                :label="$t('Date')"
                prepend-inner-icon="event"
                hide-details
                readonly
                name="Date"
                :error="errors.has('Date')"
                v-validate="'required|date_format:yyyy-MM-dd'"
              />
              <v-date-picker @change="theDateMenu = false" v-model="date" @input="updateDatatableResult()" />
            </v-menu>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-card>

    <v-card class="px-4 pb-4">
      <v-data-table
        v-show="isDatatable"
        :headers="headers"
        :items="resultData.data"
        :item-key="defaultSortBy"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="pagination.rowsPerPageItems"
        :total-items="resultData.total"
        :no-data-text="$t('No available data')"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <!--          <td>{{ props.item.product_id }}</td>-->
          <!--          <td align="center">-->
          <!--            <a-->
          <!--              v-if="props.item.product_image"-->
          <!--              class="ma-2 image-frame"-->
          <!--              @click=";(imageSrc = props.item.product_image), (dialogs.imageViewerDialog = true)"-->
          <!--              :style="-->
          <!--                `-->
          <!--                display:block;-->
          <!--                background: #EEE url(${baseUrls.images}/${props.item.product_image}) no-repeat;-->
          <!--                background-position: center center;-->
          <!--                background-size: cover;-->
          <!--                width: 80px;-->
          <!--                height: 60px;-->
          <!--              `-->
          <!--              "-->
          <!--            />-->
          <!--            <div-->
          <!--              v-else-->
          <!--              class="ma-2 image-frame"-->
          <!--              :style="-->
          <!--                `-->
          <!--                display:block;-->
          <!--                background: rgba(3, 13, 39, 0.9);-->
          <!--                width: 80px;-->
          <!--                height: 60px;-->
          <!--              `-->
          <!--              "-->
          <!--            />-->
          <!--          </td>-->
          <td>{{ props.item.product_name }}</td>
          <!--          <td>{{ $t(props.item.product_or_raw_or_fixed) }}</td>-->
          <td>{{ props.item.product_barcode }}</td>
          <td>{{ props.item.product_type_name }}</td>
          <!--          <td>{{ props.item.input }}</td>-->
          <!--          <td>{{ props.item.output }}</td>-->
          <td>{{ props.item.quantity | currency }}</td>
          <!--          <td>{{ props.item.quantity_alarm_total }}</td>-->
          <!--          <td>-->
          <!--            <v-tooltip top>-->
          <!--              <v-chip-->
          <!--                slot="activator"-->
          <!--                label-->
          <!--                :color="props.item.shortage ? 'warning' : 'success'"-->
          <!--                text-color="white"-->
          <!--                class="no-select"-->
          <!--              >-->
          <!--                <v-icon>{{ props.item.shortage ? 'warning' : 'check_circle' }}</v-icon>-->
          <!--              </v-chip>-->
          <!--              <span>{{ props.item.shortage ? $t('Shortage') : $t('No Shortage') }}</span>-->
          <!--            </v-tooltip>-->
          <!--          </td>-->
          <td v-if="hasActionsMenuPermissions()">
            <v-menu offset-y bottom :left="!$vuetify.rtl" :right="$vuetify.rtl" transition="slide-y-reverse-transition">
              <v-btn flat fab icon class="transparent py-2" slot="activator">
                <v-icon large class="grey--text actions-btn">more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-tooltip v-if="hasPermissions(['inventory_show'])" :left="!$vuetify.rtl" :right="$vuetify.rtl">
                  <v-list-tile slot="activator" @click="viewRecord(props.item.product_id)">
                    <v-icon>chrome_reader_mode</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('datatable-view') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`View Total Inventory's information`) }}</span>
                </v-tooltip>
              </v-list>
            </v-menu>
          </td>
        </template>

        <v-alert slot="no-results" :value="true" color="error" icon="warning">{{
          $t('Sorry, No results found for your search criteria')
        }}</v-alert>
      </v-data-table>

      <dt-pagination
        :resultData="resultData"
        :pagination="pagination"
        :perPageNumber="perPageNumber"
        @page-changed="pageChanged"
        @per-page-changed="resultsPerPageChanged"
      />
    </v-card>

    <view-total-inventory :viewDialog="dialogs.viewDialog" @hidemodal="dialogs.viewDialog = false" />

    <app-image-viewer
      :imageSrc="imageSrc"
      :maxWidth="700"
      :imageViewerDialog="dialogs.imageViewerDialog"
      @hidemodal="dialogs.imageViewerDialog = false"
    />

    <print-export-component
      :printExportDialog="dialogs.printExportDialog"
      :tableHeader="tableHeader"
      :tableBody="tableBody"
      :clickedButton="clickedButton"
      @hidemodal="dialogs.printExportDialog = false"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import Axios from 'axios'

export default {
  components: {
    dtSearchBox: () => import('@/views/_partials/AppSearchBox.vue'),
    dtPagination: () => import('@/views/_partials/AppDatatablePagination.vue'),
    printExportComponent: () => import('@/views/_partials/printExportComponent.vue'),
    viewTotalInventory: () => import('./viewTotalInventory.vue'),
    AppImageViewer: () => import('@/views/_partials/AppImageViewer.vue')
  },

  data() {
    return {
      dialogs: {
        viewDialog: false,
        imageViewerDialog: false,
        printExportDialog: false
      },
      tableBody: [],
      tableHeader: [],
      loadThePrintBtn: false,
      loadTheExportBtn: false,
      clickedButton: '',
      theDateMenu: false,
      outletId: 0,
      isDatatable: true,
      date: this.$moment()
        .format()
        .substr(0, 10),
      search: null,
      oldSearch: null,
      loading: false,
      defaultSortBy: 'product_id',
      perPageNumber: 10,
      pagination: {
        sortBy: this.defaultSortBy,
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 1
      },
      oldPagination: {},
      headers: [
        // {
        //   text: this.$t('ID'),
        //   value: 'product_id',
        //   align: 'left',
        //   sortable: true
        // },
        // { text: this.$t('Product Image'), value: '', align: 'center' },
        { text: this.$t('Asset Name'), value: 'product_name' },
        // { text: this.$t('Asset Type'), value: 'product_or_raw_or_fixed' },
        { text: this.$t('Barcode'), value: 'product_barcode' },
        { text: this.$t('Asset Type'), value: 'product_type_name' },
        // { text: this.$t('Input'), value: 'input' },
        // { text: this.$t('Output'), value: 'output' },
        { text: this.$t('Balance'), value: 'quantity' }
        // {
        //   text: this.$t('Total Balance Alarm'),
        //   value: 'quantity_alarm_total'
        // },
        // { text: this.$t('Shortage'), value: 'shortage' }
      ],
      allowGettingData: true,
      imageSrc: null
    }
  },

  mounted() {
    this.setAppBarTitle({
      title: this.$t('Inventories Report'),
      icon: 'fa-chart-line'
    })

    if (this.hasActionsMenuPermissions()) {
      this.headers.push({
        text: this.$t('datatable-actions'),
        value: '',
        sortable: false
      })
    }

    this.fetchOutletList()
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      resultData: 'inventory/getTotalInventoryList',
      outletsList: 'outlets/getFullReportOutletsList'
    })
  },

  watch: {
    pagination: {
      immediate: true,
      deep: true,
      handler() {
        let p = this.pagination
        let op = this.oldPagination
        if (p.sortBy !== op.sortBy || p.descending !== op.descending) {
          op.sortBy = p.sortBy
          op.descending = p.descending
          p.page = 1
          this.updateDatatableResult()
          this.allowGettingData = !this.allowGettingData
        } else if (this.allowGettingData || this.search !== this.oldSearch) {
          this.oldSearch = this.search
          this.updateDatatableResult()
          this.allowGettingData = !this.allowGettingData
        }
      }
    }
  },

  methods: {
    ...mapActions({
      resetAllErrors: 'errors/resetAllErrors',
      setErrorsList: 'errors/setErrorsList',
      updateResult: 'inventory/updateReportInventoryList',
      fetchTotalInventoryInfo: 'inventory/fetchTotalInventoryInfo',
      fetchOutletList: 'outlets/setFullOutletsList'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    hasActionsMenuPermissions() {
      return helpers.userHasPermissions(['inventory_show'])
    },

    getNoPaginatedData(clickedButton) {
      this.clickedButton = clickedButton
      if (clickedButton === 'print') {
        this.loadThePrintBtn = true
      } else if (clickedButton === 'export') {
        this.loadTheExportBtn = true
      }
      this.tableBody = []
      this.tableHeader = []
      this.tableHeader = this.headers
      this.tableHeader = this.tableHeader.filter(f => f.text !== 'Actions' && f.text !== 'الاجراءات')

      Axios.get(`report_inventories/${this.outletId}/${this.date}`, {
        params: { is_paginated: 0, search: this.search }
      })
        .then(response => {
          this.tableBody = response.data.data
          this.loadThePrintBtn = false
          this.loadTheExportBtn = false
          this.dialogs.printExportDialog = true
        })
        .catch(() => {
          this.loadThePrintBtn = false
          this.loadTheExportBtn = false
          this.dialogs.printExportDialog = false
        })
    },

    updateDatatableResult() {
      this.loading = true
      let payload = {
        ...this.pagination,
        search: this.search,
        outlet_id: this.outletId,
        date: this.date
      }
      this.updateResult(payload)
        .then(() => {
          this.pagination.page = this.resultData.current_page
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    resetDataTable() {
      this.allowGettingData = true
      this.date = this.$moment()
        .format()
        .substr(0, 10)
      this.pagination = {
        sortBy: null,
        descending: true,
        page: 1,
        rowsPerPage: this.perPageNumber,
        totalItems: 1
      }
      this.search = this.oldSearch = null
    },

    resultsPerPageChanged(val) {
      this.perPageNumber = val
      this.pagination.rowsPerPage = val
      this.pagination.page = 1
      this.updateDatatableResult()
    },

    pageChanged(val) {
      this.pagination.page = val
      this.updateDatatableResult()
    },

    searchValue(val) {
      this.search = val
    },

    viewRecord(id) {
      let payload = { product_id: id, date: this.date }
      this.fetchTotalInventoryInfo(payload).then(() => {
        this.dialogs.viewDialog = true
      })
    }
  }
}
</script>

<style scoped />
